import loadImage from '/expert/mobile/loadImage.js';
import preloadImages from '/expert/mobile/preloadImages.js';

export default {
  loadImage,
  preloadImages,
};
